import { Hero } from '@/components/marketing/Hero';
import { ProductGrid } from '@/components/marketing/ProductGrid';
import { WhyDebtNet } from '@/components/marketing/WhyDebtNet';
import { FeatureCarousel } from '@/components/marketing/FeatureCarousel';
import { PricingTeaser } from '@/components/marketing/PricingTeaser';
import { Testimonials } from '@/components/marketing/Testimonials';
import { SellerRegistration } from '@/components/marketing/SellerRegistration';
import { CTA } from '@/components/marketing/CTA';
import { Footer } from '@/components/marketing/Footer';
import { AnimatedBackground } from '@/components/AnimatedBackground';

const Index = () => {
  return (
    <div className="min-h-screen">
      <AnimatedBackground opacity={0.15} nodeCount={30} />
      <Hero />
      <ProductGrid />
      <WhyDebtNet />
      <FeatureCarousel />
      <PricingTeaser />
      <Testimonials />
      <SellerRegistration />
      <CTA />
      <Footer />
    </div>
  );
};

export default Index;
